export const CardPaymentMethods = {
  BR_DGE: 'br_dge',
  FIRSTDATA: 'firstdata',
  TRUSTPAYMENTS: 'trustpayments',
  CASHFLOWS: 'cashflows',
  CHECKOUT: 'checkout'
} as const;

export const NonCardPaymentMethods = {
  PAYPAL: 'paypal',
  UTRUST: 'utrust',
  FREE: 'free'
} as const;

export const PaymentGatewayNames = {
  CARD: 'card'
} as const;

export const DEFAULT_CARD_PAYMENT_METHOD: CardPaymentMethod = CardPaymentMethods.BR_DGE;

export type CardPaymentMethod =
  (typeof CardPaymentMethods)[keyof typeof CardPaymentMethods];
export type NonCardPaymentMethod =
  (typeof NonCardPaymentMethods)[keyof typeof NonCardPaymentMethods];
export type PaymentGatewayName = CardPaymentMethod | NonCardPaymentMethod;
export type ChosenPaymentMethod =
  | (typeof PaymentGatewayNames)['CARD']
  | NonCardPaymentMethod;

export class PaymentSubmission {
  returnPath?: string;
  preferredProcessor: PaymentGatewayName;
  paymentCardId?: string | null;
  cardNumber?: string | null;
  expMonth?: string | null;
  expYear?: string | null;
  securityCode?: string | null;
  subProcessor?: string | null;
  flags?: string[];
  agreeToOrderAboveThreshold?: boolean | null;
}

export type PaymentGateways = Record<string, number>;
